/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Note_Added_TitleInputs */

const en_notifications_note_added_title = /** @type {(inputs: Notifications_Note_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New note on case ${i?.caseNumber}`)
};

const pt_br2_notifications_note_added_title = /** @type {(inputs: Notifications_Note_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nova nota no caso ${i?.caseNumber}`)
};

/**
* | output |
* | --- |
* | "New note on case {caseNumber}" |
*
* @param {Notifications_Note_Added_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_note_added_title = /** @type {((inputs: Notifications_Note_Added_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Note_Added_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_note_added_title(inputs)
	return pt_br2_notifications_note_added_title(inputs)
});